import http from './http.js';

export async function fetchCart() {
  return http.get('/cart');
}

export async function addItem({ kind, bookId, quantity = 1 }) {
  return http.post('/cart/items', { kind, bookId, quantity });
}

export async function updateItem(itemId, quantity) {
  return http.put(`/cart/items/${itemId}`, { quantity });
}

export async function removeItem(itemId) {
  return http.delete(`/cart/items/${itemId}`);
}

export async function applyPromo(code) {
  return http.post('/cart/promo', { code });
}

export async function removePromo() {
  return http.delete('/cart/promo');
}

export async function mergeCart(items) {
  return http.post('/cart/merge', { items });
}

export default {
  fetchCart,
  addItem,
  updateItem,
  removeItem,
  applyPromo,
  removePromo,
  mergeCart,
};
